export default {
  GroupEmailerConfirmDraftDelete: {
    mounted() {
      this.el.addEventListener('click', () => {
        const { draftId } = this.el.dataset;

        const modal = document.querySelector('#emailer-delete-draft-modal');

        modal.querySelector('#emailer-delete-draft-button').setAttribute('phx-value-draft-id', draftId);
        window.liveSocket.execJS(modal, modal.getAttribute('data-show'));
      });
    },
  },
};
